<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <radio-question [data]="dispensation.data" [active]="dispensation.active"
                    [valueSelected]="dispensation.valueSelected"
                    (selectAnswer)="onDispensationSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <select-question [data]="pcnCancellation.data" [active]="dispensation.valueSelected !== 'n'"
                     [valueSelected]="pcnCancellation.valueSelected"
                     (selectAnswer)="onPcnCancellationSelected($event)"></select-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
